var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#000450"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.268 9.157a.45.45 0 010 .637l-6.3 6.3a.45.45 0 01-.636 0l-3.15-3.15a.45.45 0 11.636-.637l2.832 2.832 5.982-5.982a.45.45 0 01.636 0z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMC42MjUiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgcng9IjEyIiBmaWxsPSIjMDAwNDUwIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTcuMjY4IDkuMTU3MTlDMTcuNDQzNyA5LjMzMjkzIDE3LjQ0MzcgOS42MTc4NSAxNy4yNjggOS43OTM1OUwxMC45NjggMTYuMDkzNkMxMC43OTIzIDE2LjI2OTMgMTAuNTA3MyAxNi4yNjkzIDEwLjMzMTYgMTYuMDkzNkw3LjE4MTYxIDEyLjk0MzZDNy4wMDU4NyAxMi43Njc5IDcuMDA1ODcgMTIuNDgyOSA3LjE4MTYxIDEyLjMwNzJDNy4zNTczNCAxMi4xMzE1IDcuNjQyMjcgMTIuMTMxNSA3LjgxOCAxMi4zMDcyTDEwLjY0OTggMTUuMTM5TDE2LjYzMTYgOS4xNTcxOUMxNi44MDczIDguOTgxNDYgMTcuMDkyMyA4Ljk4MTQ2IDE3LjI2OCA5LjE1NzE5WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgCheckCircle as ReactComponent };